// Used to compile-time check exhaustive switch cases
// https://stackoverflow.com/a/39419171/6678216
export function assertUnreachable(x: never) {
  const error = new Error(`Shouldn't get here: '${x}'`);
  console.error(error);
  return error;
}
